module.exports = "/_next/static/images/california-0f39b8ff552fdfd9a179c07fbc01388a.svg";